const HELP_CENTER_LINKS: Record<string, Record<string, string>> = {
  it_management: {
    en: '/en_US/procurement/about-software',
  },
  projects: {
    en: '/en_US/projects',
  },
  trainings: {
    en: '/en_US/training',
  },
  ats: {
    en: '/en_US/recruitment-organization',
  },
  review_process: {
    en: '/en_US/performance-engagement',
  },
  engagement_insights: {
    en: '/en_US/performance-engagement',
  },
  expenses: {
    en: '/en_US/spending',
  },
  shift_management: {
    en: '/en_US/shift-management',
  },
  timeoff: {
    en: '/en_US/time-off-settings',
  },
  time_tracking: {
    en: '/en_US/time-tracking',
  },
  procurement: {
    en: '/en_US/procurement',
  },
  accounts_payable: {
    en: '/en_US/procurement/how-to-manage-bank-accounts-in-factorial',
  },
  benefits: {
    en: '/en_US/benefits',
  },
  sales: {
    en: '/en_US/crm',
  },
  compensations: {
    en: '/en_US/compensation',
  },
}

type HelpCenterLink = keyof typeof HELP_CENTER_LINKS

export function getHelpCenterLocalizedLink(linkKey: HelpCenterLink): string {
  const localeFallback = 'en'
  const helpCenterUrl = 'https://help.factorialhr.com'

  const matchedKey = Object.keys(HELP_CENTER_LINKS).find((moduleKey) => linkKey.includes(moduleKey))

  if (!matchedKey) return helpCenterUrl

  const helpCenterLink = HELP_CENTER_LINKS[matchedKey]

  if (!helpCenterLink) return helpCenterUrl

  const localizedLink = helpCenterLink[localeFallback]

  if (!localizedLink) return helpCenterUrl

  return `https://help.factorialhr.com${localizedLink}`
}
